<template>
  <div>
    <div>
      <NetWorkChartWindow v-if="type == 1"></NetWorkChartWindow>
      <CompanyRiskLookup v-if="type == 2"></CompanyRiskLookup>
    </div>
    <div></div>
  </div>
</template>

<script>
import CompanyRiskLookup from "@/pages/Result/H5FinancialAnalysis/companyRisk/CompanyRiskLookup";
import { getCompanyAreaList, getCompanyRiskImage } from "@/api/threeYears";
import NetWorkChartWindow from "@/pages/Result/H5FinancialAnalysis/networkChart2/NetWorkChartWindow";

export default {
  name: "UpDownCustomerNetWork",
  components: {
    CompanyRiskLookup,
    NetWorkChartWindow,
  },
  props: {
    type: [String, Number],
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="stylus" scoped></style>
